import React, {useEffect, useState} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from "../Univ.js";
function SalesGstStat(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [addedby, setAddedby] = useState({username: ""});
    const [mode, setMode] = useState({mode: ""});
    const [rows, setRows] = useState([]);
    const [userData, setUserData] = useState([]);
    const [combinedData, setcombinedData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        if (!date) {
            setStartDate(null);
            return;
        }
        const localDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
        );
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        if (!date) {
            setEndDate(null);
            return;
        }
        const localDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
        );
        setEndDate(localDate);
    };
    const handleUser = (event) => {
        setAddedby({
            ...addedby,
            username: event.target.value
        });
    };
    const handleMode = (event) => {
        setMode({
            ...mode,
            mode: event.target.value
        });
    };
    useEffect(() => {
        axios
            .get(`${baseUrl}user-search/`)
            .then((response) => {
                setUserData(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
    useEffect(() => {
        fetchData();
    }, [startDate, endDate, addedby, mode]);
    useEffect(() => {
        if (combinedData.length > 0) {
            fetchPharmData();
        } else {
            setRows([]);
        }
    }, [combinedData]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate
            ? startDate.toISOString().substring(0, 10)
            : "";
        const endDateString = endDate
            ? endDate.toISOString().substring(0, 10)
            : "";
        const url =
            `${baseUrl}all-pharm-sale/` +
            `?start_date=${startDateString}` +
            `&end_date=${endDateString}` +
            `&addedby=${addedby.username}` +
            `&mode=${mode.mode}` +
            `&status=1`;
        axios
            .get(url)
            .then((response) => {
                const filteredData = response.data.filter(
                    (item) => item.mode !== "Indent"
                );
                setcombinedData(filteredData);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    }
    function fetchPharmData() {
        const productIds = combinedData.reduce((ids, row) => {
            const products = row.product
                ? row.product.split(",").map((item) => item.trim())
                : [];
            return [...ids, ...products];
        }, []);
        if (productIds.length === 0) {
            setRows(combinedData);
            return;
        }
        Promise.all(
            productIds.map((id) =>
                axios.get(`${baseUrl}update-indent-use-bill/${id}/`)
            )
        )
            .then((responses) => {
                const updatedPharmData = responses.map(
                    (response) => response.data
                );
                const updatedCombinedData = combinedData.map((row) => {
                    const products = row.product
                        ? row.product.split(",").map((item) => item.trim())
                        : [];
                    const netAmounts = row.netamount
                        ? row.netamount
                            .split(",")
                            .map((amount) => parseFloat(amount.trim()) || 0)
                        : [];
                    const updatedProducts = products.map(
                        (product, index) => {
                            const matchingData =
                                updatedPharmData.find(
                                    (data) => data.id == product
                                );
                            if (matchingData) {
                                const cgst =
                                    matchingData.product &&
                                    parseFloat(
                                        matchingData.product.cgst
                                    );
                                return {
                                    ...(matchingData.product || {}),
                                    cgst: !isNaN(cgst)
                                        ? cgst.toFixed(1)
                                        : "0.0",
                                    netAmounts:
                                        netAmounts[index] || 0
                                };
                            } else {
                                return {
                                    id: product,
                                    cgst: "0.0",
                                    netAmounts:
                                        netAmounts[index] || 0
                                };
                            }
                        }
                    );
                    return {
                        ...row,
                        product: updatedProducts
                    };
                });
                setViewPharmData(updatedPharmData);
                setRows(updatedCombinedData);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    /*
     * ============================================================
     * GST CALCULATION WITH INVOICE DISCOUNT
     *
     * netamount = GST-inclusive product amount
     *
     * Example:
     *
     * Product A = ₹100
     * Product B = ₹200
     * Invoice Discount = ₹30
     *
     * Total = ₹300
     *
     * Product A discount:
     * 30 × (100 / 300) = ₹10
     *
     * Product B discount:
     * 30 × (200 / 300) = ₹20
     *
     * Discounted A = ₹90
     * Discounted B = ₹180
     *
     * GST is calculated from these discounted amounts.
     * ============================================================
     */
    const calculateGSTStatement = () => {
        const result = {
            "0%": 0,
            "5%": 0,
            "12%": 0,
            "18%": 0,
            "28%": 0,
            "0.0%": 0,
            "5.0%": 0,
            "12.0%": 0,
            "18.0%": 0,
            "28.0%": 0
        };
        rows.forEach((payment) => {
            const products = payment.product || [];
            /*
             * Calculate total gross amount for this invoice
             */
            const totalGross = products.reduce(
                (total, product) => {
                    return total + (
                        parseFloat(product.netAmounts) || 0
                    );
                },
                0
            );
            /*
             * Invoice-level discount
             */
            let discount = parseFloat(payment.disc) || 0;
            /*
             * Prevent discount from exceeding invoice amount
             */
            if (discount < 0) {
                discount = 0;
            }
            if (discount > totalGross) {
                discount = totalGross;
            }
            if (totalGross <= 0) {
                return;
            }
            /*
             * Calculate each product after proportional discount
             */
            products.forEach((product) => {
                const grossAmount =
                    parseFloat(product.netAmounts) || 0;
                if (grossAmount <= 0) {
                    return;
                }
                const cgst =
                    parseFloat(product.cgst) || 0;
                /*
                 * Allocate invoice discount proportionally
                 */
                const productDiscount =
                    discount * (grossAmount / totalGross);
                /*
                 * GST-inclusive amount after discount
                 */
                const discountedAmount =
                    grossAmount - productDiscount;
                /*
                 * Total GST percentage
                 */
                const gstPercent = cgst * 2;
                /*
                 * Convert GST-inclusive amount into
                 * GST-exclusive taxable amount and GST.
                 */
                let gstAmount = 0;
                if (gstPercent > 0) {
                    gstAmount =
                        discountedAmount *
                        (gstPercent / (100 + gstPercent));
                }
                const roundedGST =
                    parseFloat(gstAmount.toFixed(2));
                /*
                 * Classify according to total GST %
                 */
                if (cgst === 0) {
                    result["0%"] += discountedAmount;
                    result["0.0%"] += roundedGST;
                } else if (cgst === 2.5) {
                    result["5%"] += discountedAmount;
                    result["5.0%"] += roundedGST;
                } else if (cgst === 6) {
                    result["12%"] += discountedAmount;
                    result["12.0%"] += roundedGST;
                } else if (cgst === 9) {
                    result["18%"] += discountedAmount;
                    result["18.0%"] += roundedGST;
                } else if (cgst === 14) {
                    result["28%"] += discountedAmount;
                    result["28.0%"] += roundedGST;
                }
            });
        });
        return result;
    };
    const gstStatement = calculateGSTStatement();
    const today = new Date();
    return (
        <section className="container mt-4">

            <h3
                className="text-center"
                style={{
                    color: "white",
                    backgroundColor: "#0dcaf0"
                }}
            >
                <i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true"
                    style={{color: "red"}}
                ></i>{" "}
                Sales GST Statement
            </h3>

            <div className="row">

                {/* DATE */}
                <div className="col-md-4">

                    <label className="control-label">
                        Select Date
                    </label>

                    <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText="Please select From date"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                    />

                    <DatePicker
                        selected={endDate}
                        onChange={handleEndDateChange}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        maxDate={today}
                        placeholderText="Please select To date"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                    />

                </div>

                {/* CASHIER */}
                <div className="col-md-4">

                    <div className="mb-4 mt-4 form-control">

                        <label
                            htmlFor="user"
                            className="form-label"
                        >
                            Search by Cashier
                        </label>

                        <select
                            name="user"
                            id="username"
                            value={addedby.username}
                            className="form-control"
                            onChange={handleUser}
                        >

                            <option value="">
                                Select Cashier
                            </option>

                            {userData.map((User, index) => (
                                <option
                                    key={index}
                                    value={User.username}
                                >
                                    {User.username}
                                </option>
                            ))}

                        </select>

                    </div>

                </div>

                {/* MODE */}
                <div className="col-md-4">

                    <div className="mb-4 mt-4 form-control">

                        <label
                            htmlFor="mode"
                            className="form-label"
                        >
                            Search by Sales Mode
                        </label>

                        <select
                            name="mode"
                            id="mode"
                            value={mode.mode}
                            className="form-control"
                            onChange={handleMode}
                        >

                            <option value="">
                                Select Mode
                            </option>

                            <option value="cash">
                                Cash
                            </option>

                            <option value="card">
                                Card
                            </option>

                            <option value="creditpay">
                                Credit Payment
                            </option>

                            <option value="advance">
                                Advance
                            </option>

                            <option value="UPI">
                                UPI
                            </option>

                        </select>

                    </div>

                </div>

            </div>

            {!isLoading && combinedData.length > 0 ? (
                <div className="table-responsive">

                    <table className="erp-table-modern">

                        <thead>

                        <tr>

                            <th colSpan="5">
                                Total Sale Amount
                            </th>

                            <th colSpan="5">
                                GST Amount
                            </th>

                        </tr>

                        <tr>

                            <th>0%</th>
                            <th>5%</th>
                            <th>12%</th>
                            <th>18%</th>
                            <th>28%</th>

                            <th>0.0%</th>
                            <th>5.0%</th>
                            <th>12.0%</th>
                            <th>18.0%</th>
                            <th>28.0%</th>

                        </tr>

                        </thead>

                        <tbody>

                        <tr>

                            {[
                                "0%",
                                "5%",
                                "12%",
                                "18%",
                                "28%",
                                "0.0%",
                                "5.0%",
                                "12.0%",
                                "18.0%",
                                "28.0%"
                            ].map((key) => (
                                <td key={key}>
                                    {gstStatement[key].toFixed(2)}
                                </td>
                            ))}

                        </tr>

                        </tbody>

                    </table>

                </div>
            ) : (
                <div className="text-center">
                    loading pls wait....
                </div>
            )}

        </section>
    );
}
export default SalesGstStat;